import Immutable from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import { MEMBER_SEARCH_SCREEN } from '../constants/category';
import { COMMUNITY_DATA_KEY, JOIN_GROUP_STATUS, PAGING_DEFAULT, EVENT_TYPE } from '../constants/constants';
import newFeed from '../constants/newFeed';
import initialState from './initialState';
import TYPE from '../constants/newFeed';

const getActivityDataFromAction = action => {
  const masterData = {
    [COMMUNITY_DATA_KEY.ARTICLE]: newFeed.OTG_NAME.OTG_Article,
    [COMMUNITY_DATA_KEY.OTG]: newFeed.OTG_NAME.OTG_Gallery,
    [COMMUNITY_DATA_KEY.STORIES]: newFeed.OTG_NAME.OTG_Story,
    [COMMUNITY_DATA_KEY.OTG_PHOTO]: newFeed.OTG_NAME.OTG_Photo,
    [COMMUNITY_DATA_KEY.OTG_VIDEO]: newFeed.OTG_NAME.OTG_Video,
  };
  let id = action.params?.id || action.id,
    typeName = action.dataKey ? masterData[action.dataKey] : newFeed.OTG_NAME.OTG_Forum;
  return { id, typeName };
};
export default function memberProfileReducer(state = initialState.memberProfile, action) {
  switch (action.type) {
    case types.UPDATE_LIST_USERS_LIKED_SUCCESS: {
      const { listUsersLiked } = Immutable.asMutable(state);
      const newList = [...listUsersLiked];
      if (!newList.includes(action.userId)) {
        newList.push(action.userId);
      }
      return state.merge({ listUsersLiked: newList });
    }
    case types.GET_MEMBER_PROFILE_SUCCESS: {
      const oldState = Immutable.asMutable(state);
      let obj = oldState[action.userId];
      const cloneListUsersLiked = [...oldState.listUsersLiked];
      if (oldState[action.userId] && !!oldState[action.userId].isProfileNotFound) {
        obj = Immutable.without(oldState[action.userId], 'isProfileNotFound');
      }
      if (!cloneListUsersLiked.includes(action.userId)) {
        state = state.setIn([action.userId], { ...obj, ...action.data });
      } else {
        const removeUserId = cloneListUsersLiked.filter(item => item !== action.userId);
        const newDataProfile =
          obj && obj.profileIntersection
            ? {
                ...obj,
                ...action.data,
                profileIntersection: obj.profileIntersection,
              }
            : { ...obj, ...action.data };
        state = state.merge({
          listUsersLiked: removeUserId,
          [action.userId]: newDataProfile,
        });
      }
      return state.merge({ isLoading: false });
    }
    case types.GET_MEMBER_PROFILE_VALIDATE_SUCCESS: {
      const oldState = Immutable.asMutable(state);
      let validates = action.data;
      if (
        action.params &&
        action.params.pageNumber > 1 &&
        oldState[action.userId] &&
        oldState[action.userId].validates &&
        oldState[action.userId].validates.length > 0
      ) {
        validates = [...oldState[action.userId].validates, ...action.data];
      }
      return state.merge({
        pageNumberValidation: action.params && action.params.pageNumber > 1 ? action.params.pageNumber : 1,
        [action.userId]: {
          ...oldState[action.userId],
          validates,
          totalValidate: action.total,
          isPrivateValidations: action?.isPrivateValidations,
        },
        isLoading: false,
        hasMoreValidations: validates.length < action.total,
      });
    }

    case types.GET_MEMBER_PROFILE_ENTITIES_SUCCESS: {
      const oldState = Immutable.asMutable(state);
      return state.setIn([action.userId], {
        ...oldState[action.userId],
        ...action.entityData,
      });
    }

    case types.GET_MEMBER_PROFILE_FRIENDS_SUCCESS: {
      const oldState = Immutable.asMutable(state);
      let friends = action.data;
      if (
        action.params &&
        action.params.pageNumber > 1 &&
        oldState[action.userId] &&
        oldState[action.userId].friends &&
        oldState[action.userId].friends.length > 0
      ) {
        friends = [...oldState[action.userId].friends, ...action.data];
      }
      return state.merge({
        pageNumberFriend: action.params && action.params.pageNumber > 1 ? action.params.pageNumber : 1,
        [action.userId]: {
          ...oldState[action.userId],
          friends,
          totalFriend: action.total,
        },
        isLoading: false,
        hasMoreFriends: friends.length < action.total,
      });
    }

    case types.POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS:
    case types.POST_USERS_MEMBER_PROFILE_ACTION_SUCCESS: {
      const { userId } = action.user.detail;
      const oldState = Immutable.asMutable(state);
      if ((oldState[userId] && !!oldState[userId].profileIntersection) || action.user) {
        const { LIKE, UNLIKE, FAVORITE } = MEMBER_SEARCH_SCREEN.ACTION_TYPE;
        const _user = oldState[userId] || action.user;
        let updateObject = null;
        // switch (action.actionType) {
        //     case LIKE:
        //     case UNLIKE:
        if (action.actionSuccess) {
          if (action.actionType === LIKE) {
            updateObject = {
              isFavorited: action.params.Type === FAVORITE && action.actionType === LIKE,
              isFavoritedMutual: action.isFavouritedMutualMatch,
              isLiked: action.actionType === LIKE,
              isLikedMutual: action.isFavouritedMutualMatch ? action.isFavouritedMutualMatch : action.isLikedMutualMatch,
            };
          }
          if (action.actionType === UNLIKE) {
            if (action.params.Type === FAVORITE) {
              updateObject = {
                ...action.user.profileIntersection,
                isFavorited: false,
                isFavoritedMutual: false,
              };
              if (!action.params.isOnlyFavourite) {
                updateObject.isLiked = false;
                updateObject.isLikedMutual = false;
              }
            } else {
              updateObject = {
                ...action.user.profileIntersection,
                isLiked: false,
                isLikedMutual: false,
                // isLiked: false,
                // isLikedMutual: false
              };
            }
          }
        }
        //  break;
        // }
        if (updateObject) {
          state = state.setIn([userId], {
            ..._user,
            profileIntersection: {
              ..._user.profileIntersection,
              ...updateObject,
            },
          });
        }
      }
      return state;
    }

    case types.UPDATE_MEMBER_PROFILE_STATE: {
      return state.merge({ ...action.data });
    }

    case types.UPDATE_MEMBER_PROFILE_PROPERTY_STATE: {
      state = state.setIn([...action.data.dataKey], action.data.dataValue);
      return state;
    }

    case types.TOGGLE_PROFILE_MODAL: {
      return state.set('isShowProfileModal', action.data);
    }

    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.memberProfile;
      return state;
    }

    case types.GET_MEMBER_PROFILE_TIME_OUT: {
      const oldState = Immutable.asMutable(state);
      state = state.setIn([action.userId], {
        ...oldState[action.userId],
        ...action.data,
      });
      return state.merge({ isLoading: false });
    }
    case types.UPDATE_VIEWING_USER_ID: {
      state = state.set('userViewingId', action.userId);
      return state;
    }
    case types.GET_PROFILE_ACTIVITY_SUCCESS: {
      const oldState = Immutable.asMutable(state);
      return state.setIn([action.userId], {
        ...oldState[action.userId],
        profileActivity: [...action.data],
      });
    }
    case types.POST_CREATE_FORUM_TOPIC_UNLIKE_SUCCESS:
    case types.POST_CREATE_FORUM_TOPIC_LIKE_SUCCESS:
    case types.POST_CREATE_LIKE_COMMUNITY_SUCCESS:
    case types.POST_CREATE_UN_LIKE_COMMUNITY_SUCCESS: {
      const userViewingId = state.userViewingId;
      if ((action.isProfileActivity || action.params?.isProfileActivity) && userViewingId) {
        const { id, typeName } = getActivityDataFromAction(action);
        const _state = Immutable.asMutable(state);
        const userProfile = _state[userViewingId];
        const userProfileActivity = JSON.parse(JSON.stringify(userProfile.profileActivity));

        for (let i = 0; i < (userProfileActivity || []).length; i++) {
          const item = userProfileActivity[i];
          if (item.contentItem.id.toString() === id.toString() && item.typeName === typeName) {
            const likeCount = item.contentItem.isMemberLike ? item.contentItem.likeCount - 1 : item.contentItem.likeCount + 1;
            userProfileActivity[i] = {
              ...item,
              contentItem: {
                ...item.contentItem,
                likeCount: likeCount < 0 ? 0 : likeCount,
                isMemberLike: !item.contentItem.isMemberLike,
              },
            };
          }
        }
        return state.setIn([userViewingId], {
          ...userProfile,
          profileActivity: userProfileActivity,
        });
      }

      return state;
    }
    case types.PATCH_DATE_FINDER_INTEREST_SUCCESS:
    case types.PATCH_DATE_FINDER_UN_INTEREST_SUCCESS: {
      const { id, indexSection, indexDateFinder, userId } = action;
      const _state = Immutable.asMutable(state);
      const userProfile = _state[userId];
      const userProfileData = [];

      for (let i = 0; i < (userProfile.dateFinder || []).length; i++) {
        const item = userProfile.dateFinder[i];
        let hasExpressedInterest = item.hasExpressedInterest;
        if (item.id.toString() === id) {
          hasExpressedInterest = action.type === types.PATCH_DATE_FINDER_INTEREST_SUCCESS;
        }

        userProfileData.push({
          ...item,
          hasExpressedInterest,
        });
      }
      return state.setIn([userId], {
        ...userProfile,
        dateFinder: userProfileData,
      });
    }
    case types.GET_MY_TRAVEL_PLAN_SUCCESS:
      const { data, params } = action;
      if (params?.userId) {
        const { userId } = params;
        const oldState = Immutable.asMutable(state);
        // if (!oldState[userId].travelPlans || (oldState[userId].travelPlans && oldState[userId].travelPlans.length === 0)) {
        return state.setIn([userId], {
          ...oldState[userId],
          travelPlans: data,
        });
        // }
      }

      return state;
    case types.UPDATE_MEMBER_PROFILE_TRAVEL_PLAN_SUCCESS: {
      const { userId, travelPlanId } = action;
      const oldState = Immutable.asMutable(state);
      const newTravelPlan = oldState[userId].travelPlans.filter(item => (item.id || item.userTravelProfileID) !== travelPlanId);
      return state.setIn([userId, 'travelPlans'], newTravelPlan);
    }
    case types.GET_PROFILE_GROUPS_SUCCESS: {
      const { userId, data, size, page } = action;
      const oldState = Immutable.asMutable(state);
      const newGroups = !page || page === 1 ? data.groups : [...oldState[userId].groups.groups, ...data.groups];
      const updateData = {
        groups: newGroups,
        total: data.total,
        isHasMore: newGroups.length < data.total,
        size: size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
        page: page || 1,
      };
      return state.setIn([userId, 'groups'], updateData);
    }
    case types.JOIN_A_GROUP_SUCCESS: {
      const oldState = Immutable.asMutable(state);
      const { clubId, currentUserId, isInvited, status } = action.data;
      if (currentUserId) {
        const newGroupsData = oldState[currentUserId]?.groups?.groups?.map(itm => {
          if (itm.clubID.toString() === clubId.toString()) {
            const isPrivate = itm.joinSettings.privacyType === 'Private';
            const joinStatus = status || (isPrivate || isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING);
            return {
              ...itm,
              joinSettings: {
                ...itm.joinSettings,
                joinStatus: joinStatus,
              },
            };
          }
          return itm;
        });

        const newActivityData = (oldState[currentUserId]?.profileActivity || []).map(itm => {
          if (itm.contentItem.clubID.toString() === clubId.toString()) {
            const isPrivate = itm.contentItem.joinSettings.privacyType === 'Private';
            const joinStatus = status || (isPrivate || isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING);
            return {
              ...itm,
              contentItem: {
                ...itm.contentItem,
                joinSettings: {
                  ...itm.contentItem.joinSettings,
                  joinStatus: joinStatus,
                },
              },
            };
          }
          return itm;
        });

        state = state.setIn([currentUserId, 'groups', 'groups'], newGroupsData);
        state = state.setIn([currentUserId, 'profileActivity'], newActivityData);
      }
      return state;
    }
    case types.LEAVE_A_GROUP_SUCCESS: {
      const oldState = Immutable.asMutable(state);
      const { clubId, currentUserId } = action.data;
      if (currentUserId) {
        const newGroupsData = oldState[currentUserId]?.groups?.groups?.map(itm => {
          if (itm.clubID.toString() === clubId.toString()) {
            return {
              ...itm,
              joinSettings: {
                ...itm.joinSettings,
                joinStatus: JOIN_GROUP_STATUS.NOTJOINED,
              },
            };
          }
          return itm;
        });

        const newActivityData = (oldState[currentUserId]?.profileActivity || []).map(itm => {
          if (itm.contentItem.clubID.toString() === clubId.toString()) {
            return {
              ...itm,
              contentItem: {
                ...itm.contentItem,
                joinSettings: {
                  ...itm.contentItem.joinSettings,
                  joinStatus: JOIN_GROUP_STATUS.NOTJOINED,
                },
              },
            };
          }
          return itm;
        });

        state = state.setIn([currentUserId, 'groups', 'groups'], newGroupsData);
        state = state.setIn([currentUserId, 'profileActivity'], newActivityData);
      }
      return state;
    }
    case types.POST_CREATE_EVENT_INTEREST_SUCCESS:
    case types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS: {
      let interestCount = 1;
      if (action.type === types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS) {
        interestCount = -1;
      }

      const oldState = Immutable.asMutable(state);
      const { from, id, isUnInterest, type, currentUserId } = action.params;

      if (type === EVENT_TYPE.GROUP_POST_EVENT) {
        if (currentUserId) {
          const newActivityData = (oldState[currentUserId]?.profileActivity || []).map(item => {
            if (
              item.typeId === TYPE.EventInterestAdd ||
              item.typeId === TYPE.COMMENT.EventComment ||
              item.typeId === TYPE.COMMENT_REPLY.EventCommentReply ||
              item.typeId === TYPE.CommentLike ||
              item.typeId === TYPE.ReplyLike ||
              item.typeId === TYPE.ADDED.EventAdd
            ) {
              if (item.contentItem.id.toString() === id.toString()) {
                return {
                  ...item,
                  contentItem: {
                    ...item.contentItem,
                    hasExpressInterest: !isUnInterest,
                    interestCount: item.contentItem.interestCount + interestCount,
                  },
                };
              }
            } else if (item.typeId === TYPE.ClubPost) {
              if (item.contentItem.id.toString() === id.toString()) {
                return {
                  ...item,
                  contentItem: {
                    ...item.contentItem,
                    event: [
                      {
                        ...item.contentItem.event[0],
                        hasExpressInterest: !isUnInterest,
                        interestCount: item.contentItem.event[0].interestCount + interestCount,
                      },
                    ],
                  },
                };
              }
            }

            return item;
          });

          state = state.setIn([currentUserId, 'profileActivity'], newActivityData);
        }
      }
      return state;
    }
    default:
      return state;
  }
}
